@layer components {
  .hero-load {
    position: relative;
    --hero-h-start: 960px;
    --hero-overhang: 80px;
    --hero-overhang-negative: -80px;
  }

  @media (max-width: 767.98px) {
    .hero-load {
      --hero-h-start: 800px;
    }
  }

  .hero-load__media {
    position: relative;
    clip-path: inset(0);
  }

  .hero-load__frame {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: var(--hero-h-start, 960px);
    translate: 0 -50%;
  }

  .hero-load__frame img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .hero-load--pending .hero-load__media,
  .hero-load--animating .hero-load__media,
  .hero-load--settled .hero-load__media {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }

  .hero-load--pending .hero-load__media,
  .hero-load--animating .hero-load__media {
    z-index: 1;
    transform: translateY(calc((var(--hero-media-lift, 0px) - var(--hero-overhang, 80px)) * -1));
    clip-path: inset(var(--hero-overhang-negative, -80px) 0);
    will-change: transform, clip-path;
  }

  .hero-load--animating .hero-load__media {
    animation: hero-load-drop var(--hero-drop-ms, 900ms) var(--ease-nav)
      calc(var(--hero-mask-ms, 650ms) + var(--hero-drop-pause-ms, 280ms)) forwards;
  }

  .hero-load--settled .hero-load__media {
    transform: translateY(var(--hero-drop-y, 0px));
    clip-path: inset(0);
  }

  .hero-load--pending .hero-load__frame,
  .hero-load--animating .hero-load__frame {
    clip-path: inset(var(--hero-mask-inset, 44%));
    will-change: clip-path;
  }

  .hero-load--animating .hero-load__frame {
    animation: hero-load-reveal var(--hero-mask-ms, 650ms) var(--ease-nav) forwards;
  }

  .hero-load--pending .hero-load__frame img,
  .hero-load--animating .hero-load__frame img {
    scale: 1.2;
    will-change: scale;
  }

  .hero-load--animating .hero-load__frame img {
    animation: hero-load-image-scale var(--hero-mask-ms, 650ms) var(--ease-nav) forwards;
  }

  .hero-load--pending .hero-load__content {
    visibility: hidden;
  }

  .hero-load--animating .hero-load__content,
  .hero-load--animating .hero-load__copy,
  .hero-load--animating .hero-load__stats {
    visibility: visible;
  }

  .hero-load--animating .hero-load__copy {
    opacity: 0;
    animation: hero-load-content var(--hero-content-ms, 700ms) var(--ease-nav)
      var(--hero-content-delay, 1050ms) forwards;
  }

  .hero-load--animating .hero-load__stats {
    opacity: 0;
    animation: hero-load-stats-ready 1ms linear var(--hero-mask-ms, 650ms) forwards;
  }

  @keyframes hero-load-reveal {
    from {
      clip-path: inset(var(--hero-mask-inset, 44%));
    }
    to {
      clip-path: inset(0);
    }
  }

  @keyframes hero-load-image-scale {
    from {
      scale: 1.2;
    }
    to {
      scale: 1;
    }
  }

  @keyframes hero-load-drop {
    from {
      transform: translateY(calc((var(--hero-media-lift, 0px) - var(--hero-overhang, 80px)) * -1));
      clip-path: inset(var(--hero-overhang-negative, -80px) 0);
    }
    to {
      transform: translateY(var(--hero-drop-y, 0px));
      clip-path: inset(0);
    }
  }

  @keyframes hero-load-content {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes hero-load-stats-ready {
    to {
      opacity: 1;
    }
  }

  .hero-card {
    background: #fff;
    filter: drop-shadow(0 12px 32px rgb(0 0 0 / 0.16)) drop-shadow(0 2px 8px rgb(0 0 0 / 0.08));
  }

  .hero-card--pending {
    visibility: hidden;
  }

  .hero-card--revealed {
    animation: hero-card-reveal var(--hero-card-ms, 700ms)
      var(--ease-out-strong, cubic-bezier(0.16, 1, 0.3, 1)) var(--hero-card-delay, 160ms) both;
  }

  @keyframes hero-card-reveal {
    from {
      transform: scale(var(--hero-card-start-scale-x, 0.2), var(--hero-card-start-scale-y, 0.2667));
      border-radius: 50%;
    }
    to {
      transform: scale(1);
      border-radius: var(--hero-card-radius, 40px);
    }
  }

  .hero-card__body {
    opacity: 0;
  }

  .hero-card--revealed .hero-card__body {
    animation: hero-card-content-in 450ms var(--ease-out-strong, cubic-bezier(0.16, 1, 0.3, 1))
      calc(var(--hero-card-delay, 160ms) + var(--hero-card-ms, 700ms)) both;
  }

  @keyframes hero-card-content-in {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-load__media-slot {
    display: none;
  }

  .hero-card--revealed {
    animation: none;
  }

  .hero-card__body {
    opacity: 1;
    animation: none;
  }

  .hero-load--pending .hero-load__content,
  .hero-load--animating .hero-load__content,
  .hero-load--animating .hero-load__copy,
  .hero-load--animating .hero-load__stats {
    visibility: visible;
    opacity: 1;
    animation: none;
  }

  .hero-load--pending .hero-load__media,
  .hero-load--animating .hero-load__media {
    position: relative;
    top: auto;
    right: auto;
    left: auto;
    margin-top: 1.25rem;
  }

  .hero-load--pending .hero-load__media,
  .hero-load--animating .hero-load__media,
  .hero-load--pending .hero-load__frame,
  .hero-load--animating .hero-load__frame,
  .hero-load--pending .hero-load__frame img,
  .hero-load--animating .hero-load__frame img {
    clip-path: none;
    scale: 1;
    transform: none;
    animation: none;
    will-change: auto;
  }
}
